<template>
  <v-container class="mt-4 ml-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title primary-title>
            <span class="text-subtitle-1">Mis pagos</span>
            <v-spacer></v-spacer>

            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>
          </v-card-title>
          
          <v-card-text>
            <v-row>
              <v-col cols="12" lg="5" md="6">
                <v-radio-group
                  v-model="tipoPago"
                  row
                >
                  <v-radio
                    label="Colegiaturas"
                    :value="1"
                  ></v-radio>
                  <v-radio
                    label="Paquetes"
                    :value="2"
                  ></v-radio>
                  <v-radio
                    label="Artículos"
                    :value="3"
                  ></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12" lg="2" md="6">
                <v-text-field
                  label="Fecha Inicio"
                  filled
                  dense
                  type="date"
                  hide-details
                  v-model="fecha"
                ></v-text-field>
              </v-col>

              <v-col cols="12" lg="2" md="6">
                <v-text-field
                  label="Fecha Final"
                  filled
                  dense
                  type="date"
                  hide-details
                  v-model="fechaFin"
                ></v-text-field>
              </v-col>
            </v-row>


            <v-row justify="end">

              <v-col cols="12" lg="6" md="12">
                <v-text-field
                  name="name"
                  label="Buscar"
                  id="id"
                  filled
                  dense
                  hide-details
                  append-icon="mdi-magnify"
                  v-model="search"
                ></v-text-field>
              </v-col>

            </v-row>

            <!-- Diseño del reporte -->
            <v-row>
              <v-col cols="12">

                <CArticulos
                  :headersGrupos="headersGrupos"
                  :filterPagosGruposList="filterPagosGruposList"
                  :search="search"
                  @deleteItem="deleteItem"
                  v-if="tipoPago == 1"
                  :tipoPago="tipoPago"
                />

                <CArticulos
                  :headersGrupos="headers"
                  :filterPagosGruposList="filterPagosPaquetesList"
                  :search="search"
                  @deleteItem="deleteItem"
                  v-if="tipoPago == 2"
                  :tipoPago="tipoPago"
                />

                <CArticulos
                  :headersGrupos="headers"
                  :filterPagosGruposList="filterPagosArticulosList"
                  :search="search"
                  @deleteItem="deleteItem"
                  v-if="tipoPago == 3"
                  :tipoPago="tipoPago"
                />
                
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>
<script>

  import axios from 'axios';
  import { mapGetters } from 'vuex'
  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';
  import CArticulos            from '@/components/inscripciones/articulosAlumno.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'
  import funcionesBasicasPagos from '@/mixins/funcionesBasicasPagos'


  export default {

    mixins: [ validarErrores, funcionesExcel, funcionesBasicasPagos ],

    components:{
      Alerta,
      carga,
      CArticulos
    },

    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      tipoPago: 1,

      fecha: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      fechaFin: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),


      opPago: null,
      paquete: null,
      paquetes: [],
      cantidad:1,
      comprarPaquetes : [],
      comprarArticulos: [],

      url: '',
      tipo_pago: null,
      tipos_pago:[
        { id: 1, tipo: 'EFECTIVO'},
        { id: 2, tipo: 'DEPOSITO / TRANSFERENCIA'},
        { id: 4, tipo: 'TARJETA' },
      ],

      dragging: false,
      vistaPrevia: [],
      archivos:null,

      file: null,


      dialog: false,
      dialogDelete: false,
      
      editedIndex: -1,

      editedItem: {
        idgrupos:0,
        idplanteles:null,
        idhorarios:null,
        idcursos:null,
        cupo:null,
        idmaestros:null,
        fechainicio:null,
        fechafinal:null,
        deleted:0,
        fecha_creacion:null,
      },

      defaultItem: {
        idgrupos:0,
        idplanteles:null,
        idhorarios:null,
        idcursos:null,
        cupo:null,
        idmaestros:null,
        fechainicio:null,
        fechafinal:null,
        deleted:0,
        fecha_creacion:null,
      },

      // Filtros: 
      incio:null,
      fin:null,

      // tabla
      search:'',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      cursos: [],

      headers: [
        { text: 'Alumno'        , value: 'alumno'        },
        { text: 'Tipo de pago'  , value: 'forma_pago'    },
        { text: 'Plantel'       , value: 'plantel'       },
        { text: 'Pagado'        , value: 'pagado'        },
        { text: 'Fecha Alta'    , value: 'fecha_creacion' },
        { text: 'Actions'       , value: 'actions', sortable: false },
      ],

      headersGrupos:[
        { text: 'Alumno'        , value: 'alumno'        },
        { text: 'Curso'         , value: 'curso'         },
        { text: 'Semana'        , value: 'semana'        },
        { text: 'Mes'           , value: 'mes'        },
        { text: 'Horario'       , value: 'horario'       },
        { text: 'Tipo de pago'  , value: 'forma_pago'    },
        { text: 'Plantel'       , value: 'plantel'       },
        { text: 'Pagado'        , value: 'pagado'        },
        { text: 'Fecha Alta'    , value: 'fecha_creacion' },
        { text: 'Actions'       , value: 'actions', sortable: false },
      ],

      headersAlumnos: [
        { text: 'ID'       , value: 'idgruposalumnos'  },
        { text: 'Alumno'   , value: 'alumno'           },
        { text: 'Teléfono' , value: 'telefono'         },
        { text: 'Edad'     , value: 'edad'             },
        { text: 'Correo'   , value: 'correo'           },
        { text: 'Actions'  , value: 'actions', sortable: false },
      ],

      headersPasquetes: [
        { text: 'ID'       , value: 'idpaquetes' },
        { text: 'Nombre'   , value: 'nombre' },
        { text: 'Costo'    , value: 'costo' },
        { text: 'Cantidad' , value: 'cantidad' },
        { text: 'Costo T.' , value: 'costo_total' },
        { text: 'Foto'     , value: 'foto' },
        { text: 'Acciones' , value: 'actions', sortable: false },
      ],

      headersArticulos: [
        { text: 'ID'       , value: 'idarticulos' },
        { text: 'Nombre'   , value: 'articulo'    },
        { text: 'Costo'    , value: 'precio'      },
        { text: 'Cantidad' , value: 'cantidad'    },
        { text: 'Costo T.' , value: 'costo_total' },
        { text: 'Foto'     , value: 'foto' },
        { text: 'Acciones' , value: 'actions', sortable: false },
      ],

      cursos:[],
      horarios:[],
      planteles:[],
      alumnos:[],
      inscritos:[],
      teachers:[],
      dialogAlumnos:false,
      alumno: null,

      deleteAlumno: {
        idgruposalumnos:0,
        deleted: 0
      },

      dialogDeleteAlumno: false,
      pagado: 0,

      forma_pago: null,
      articulo: null,
      articulos:[],
      pagosPaquetesList:[],
      pagosArticulosList:[],
      grupoAnterior: null,
      grupos:[],
      grupo: null,
      frecuencia_pago: null,
      pago_inscripcion: 0,
      total_pagado_grupo:0,
      pagosGruposList:[],

      plantel: null,

      semana: 0,
      mes: 0,

      pasoPago: 1,
      multa: 0,
    }),

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

      dialogAlumnos ( val ){
        val || this.closeAlumnos( )
      },

      opPago( value ){

        if( value  == 1 && this.alumno ){ this.consultarExistenciaAlumno( ) }
        if( value  == 2 && this.alumno ){ this.validarAdeudoPaquete( ) }
        if( value  == 3 ){ this.pasoPago = 3 }

      },

    },

    async created () {
      this.url = this.$http.options.root + 'articulos-enlace/';

      console.log( this.getdatosUsuario, 'u' )

      await this.initialize()
      await this.getPaquetes()
      await this.getArticulos()
      await this.getAlumnos()
      await this.getGrupos()
      await this.getPlanteles( )
    },

    methods: {
      initialize () {
        this.pagosPaquetes( )
        this.pagosArticulos( )
        this.pagosGrupos( )
      },

      pagosPaquetes () {
        this.cargar = true
        this.pagosPaquetesList = []
        const payload = {
          fecha: this.fecha,
          fechaFin: this.fechaFin
        }

        return this.$http.post('compras.paquetes', payload).then(response=>{
          this.pagosPaquetesList = response.data
          console.log( this.pagosPaquetesList )
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      pagosArticulos () {
        this.cargar = true
        this.pagosArticulosList = []
        const payload = {
          fecha: this.fecha,
          fechaFin: this.fechaFin
        }

        return this.$http.post('compras.articulos', payload ).then(response=>{
          this.pagosArticulosList = response.data
          console.log( this.pagosArticulosList )
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      pagosGrupos () {
        this.cargar = true
        this.pagosGruposList = []
        const payload = {
          fecha: this.fecha,
          fechaFin: this.fechaFin
        }

        return this.$http.post('compras.grupos', payload).then(response=>{
          this.pagosGruposList = response.data
          console.log( this.pagosGruposList )
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      deleteItem(item) {
        this.editedIndex = this.alumnos.indexOf(item);
        this.editedItem = Object.assign({}, item);
        console.log( this.editedItem )
        this.dialogDelete = true;
      },


      getPaquetes () {
        this.cargar = true
        this.paquetes = []
        return this.$http.get('paquetes.list').then(response=>{
          this.paquetes = response.data
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getArticulos () {
        this.cargar = true
        this.articulos = []
        return this.$http.get('articulos.list').then(response=>{
          this.articulos = response.data
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getGrupos ( ) {
        this.cargar = true
        this.grupos = []
        return this.$http.get('grupos.activos').then(response=>{
          this.grupos = response.data
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      addPaquetes( ){

        // Validar que haya un paquete seleccionado
        if( this.paquete ){

          this.comprarPaquetes.push({
            idpaquetes: this.paquete.idpaquetes,
            nombre:     this.paquete.nombre,
            foto:       this.paquete.foto,
            cantidad:   this.cantidad,
            costo:      this.paquete.precio,
            costo_total: ( this.paquete.precio * this.cantidad)
          })

          this.paquete  = null
          this.cantidad = 1

        }
      },

      addArticulos( ){

        // Validar que haya un paquete seleccionado
        if( this.articulo ){

          this.comprarArticulos.push({
            idarticulos: this.articulo.idarticulos,
            articulo:    this.articulo.articulo,
            foto:        this.articulo.foto,
            cantidad:    this.cantidad,
            precio:      this.articulo.precio,
            costo_total: ( this.articulo.precio * this.cantidad)
          })

          this.articulo  = null
          this.cantidad = 1

        }
      },

      getPlanteles () {
        this.cargar = true
        this.planteles = []
        return this.$http.get('planteles.list.erp').then(response=>{
          this.planteles = response.data
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getHorarios () {
        this.cargar = true
        this.horarios = []
        return this.$http.get('horarios.list').then(response=>{
          this.horarios = response.data
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getUsuarios () {
        this.cargar = true
        this.usuarios = []
        return this.$http.get('users').then(response=>{
          this.usuarios = response.data
          this.teachers = response.data.filter( el => el.idpuestos == 27 )
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getAlumnos () {
        this.cargar = true
        this.alumnos = []
        return this.$http.get('alumnos.list').then(response=>{
          this.alumnos = response.data
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })

        this.pasoPago = 1
      },

      closeAlumnos () {
        this.dialogAlumnos = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save ( op ) {
        this.cargar = true

        if( op == 1 ){

          // Iniciamos las validaciones
          if( this.pagado <= 0 ){ return this.validarErrorDirecto('Favor de ingresar un pago') }
          if( !this.comprarPaquetes.length > 0){ return this.validarErrorDirecto('Favor de seleccionar un paquete') }

          this.compraPaquete( )
        }

        if( op == 2 ){
          this.compraArticulo( )
        }

        if( op == 3 ){
          this.realizarInscripcion( )
        }
      },

      deleteItemConfirm() {
        // Lo mandapos por el EP
        this.editedItem.deleted = 1;
        this.$http.put("pagos.update/" + this.editedItem.idpagos_grupos_detalles, this.editedItem ).then((response) => {
          this.dialogSuccess = true;
          this.cargar = false;
          this.closeDelete();
          this.initialize();
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      compraPaquete( ){

        // Creamos el documento
        let formData = new FormData();
        // agregamos el documento
        formData.append("file"         , this.files                          );
        formData.append("idalumnos"    , this.alumno                         );
        formData.append("pagado"       , this.pagado                         );
        formData.append("forma_pago"   , this.forma_pago                     );
        formData.append("usuario_creo" , this.getdatosUsuario.id             );
        formData.append("idplantel"    , this.getdatosUsuario.idplanteles    );
        formData.append("paquetes"     , JSON.stringify(this.comprarPaquetes));
        formData.append("adeudo"       , this.adeudoPaquete );
        formData.append("costo"        , this.pagoPaquete );
        formData.append("adeudoAnt"    , this.tieneAdeudoPaquete );
        formData.append("info"         , this.infoPaqueteAdeudo ? this.infoPaqueteAdeudo.idpagos_paquetes : 0 );

        // Lo mandapos por el EP
        this.$http.post('comprar.paquete', formData ).then(response=>{

          this.files = null
          this.alumno = null
          this.pagado = 0
          this.forma_pago = null
          this.comprarPaquetes = []
          this.grupoAnterior = null
          this.opPago = null
          this.pasoPago = 1
          this.close( )
          this.initialize( )
          this.cargar = false

        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      compraArticulo( ){

        // Creamos el documento
        let formData = new FormData();
        // agregamos el documento
        formData.append("file"         , this.files                          );
        formData.append("idalumnos"    , this.alumno                         );
        formData.append("pagado"       , this.pagado                         );
        formData.append("forma_pago"   , this.forma_pago                     );
        formData.append("usuario_creo" , this.getdatosUsuario.id             );
        formData.append("idplantel"    , this.getdatosUsuario.idplanteles    );
        formData.append("articulos"    , JSON.stringify(this.comprarArticulos));

        // Lo mandapos por el EP
        this.$http.post('comprar.articulos', formData ).then(response=>{

          this.files = null
          this.alumno = null
          this.pagado = 0
          this.forma_pago = null
          this.comprarArticulos = []
          this.grupoAnterior = null
          this.opPago = null
          this.close( )
          this.initialize( )
          this.cargar = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      realizarInscripcion( ){

        // Creamos el documento
        let formData = new FormData();
        // agregamos el documento
        formData.append("file"            , this.files                          );
        formData.append("idalumnos"       , this.alumno                         );
        formData.append("idgrupos"        , this.grupo.idgrupos                 );
        formData.append("inscripcion"     , this.pago_inscripcion               );
        formData.append("usuario_creo"    , this.getdatosUsuario.id             );
        formData.append("frecuencia_pago" , this.frecuencia_pago                );
        formData.append("pago_recurrente" , this.total_pagado_grupo             );
        formData.append("idsucursales"    , this.getdatosUsuario.idplanteles    );
        formData.append("pagado"          , parseFloat( this.pagado ) - parseFloat( this.adeudoColegiatura ) );
        formData.append("forma_pago"      , this.forma_pago                     );
        formData.append("semana"          , this.semana                         );
        formData.append("mes"             , this.mes                            );
        formData.append("adeudo"          , parseFloat( this.adeudoColegiatura ) );
        
        // Lo mandapos por el EP
        this.$http.post('comprar.grupos', formData ).then(response=>{

          this.files = null
          this.alumno = null
          this.pagado = 0
          this.forma_pago = null
          this.grupo = null
          this.pago_inscripcion = 0
          this.frecuencia_pago = null
          this.total_pagado_grupo= 0
          this.grupoAnterior = null
          this.opPago = null

          this.comprarArticulos = []
          this.close( )
          this.initialize( )
          this.cargar = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })

      },

      realizarInscripcion2( ){

        // Creamos el documento
        let formData = new FormData();
        // agregamos el documento
        formData.append("file"            , this.files                          );
        formData.append("idalumnos"       , this.alumno                         );
        formData.append("idgruposalumnos" , this.grupoAnterior.idgruposalumnos  );
        formData.append("inscripcion"     , 0                                   );
        formData.append("usuario_creo"    , this.getdatosUsuario.id             );
        formData.append("frecuencia_pago" , this.grupoAnterior.frecuencia_pago  );
        formData.append("pago_recurrente" , this.grupoAnterior.pago_recurrente  );
        formData.append("idsucursales"    , this.getdatosUsuario.idplanteles    );
        formData.append("forma_pago"      , this.forma_pago                     );
        formData.append("pagado"          , parseFloat( this.pagado - this.cambioGrupoPagoAnterior ) - parseFloat( this.adeudoColegiatura ) );
        formData.append("mes"             , this.mes );
        formData.append("semana"          , this.semana );
        formData.append("adeudo"          , parseFloat( this.adeudoColegiatura ) );
        
        // Lo mandapos por el EP
        this.$http.post('comprar.grupos.detalle', formData ).then(response=>{

          this.files = null
          this.alumno = null
          this.pagado = 0
          this.forma_pago = null
          this.grupo = null
          this.pago_inscripcion = 0
          this.frecuencia_pago = null
          this.total_pagado_grupo= 0
          this.grupoAnterior = null
          this.semana = 0
          this.mes = 0
          this.opPago = null
          this.multa = 0

          this.comprarArticulos = []
          this.close( )
          this.initialize( )
          this.cargar = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })

      },


      consultarExistenciaAlumno( ){

        const payload = {
          idalumnos: this.alumno,
        }

        // Lo mandapos por el EP
        this.$http.post('alumno.inscrito', payload ).then(response=>{

          this.grupoAnterior = response.data
          this.pasoPago = 3

          this.cargar = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })

      },

      onChange(e) {
        var files = e.target.files || e.dataTransfer.files;
        
        if (!files.length) {
          this.dragging = false;
          return;
        }
        
        this.createFile(files[0]);
      },

      createFile(file) {
        if (!file.type.match('image.*')) {
          alert('please select txt file');
          this.dragging = false;
          return;
        }
        
        if (file.size > 10000000) {
          alert('please check file size no over 5 MB.')
          this.dragging = false;
          return;
        }
        
        this.file = file;
        this.archivos = file;
        this.getBase64(this.archivos)
        this.dragging = false;
      },

      removeFile() {
        this.total_pagado = 0
        this.vistaPrevia        = null
        this.archivos           = null
        this.file               = '';
        this.banco              = ''
        this.isSpin             = false
      },

      getBase64(file) {
        var me = this
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          me.vistaPrevia = {
            url: reader.result, 
            image_name: file.name
          }
        };
      },

      format( valor ){
        return valor.toLocaleString('es-MX', {
          style: 'currency',
          currency: 'MXN'
        });
      },
    },
  }
</script>


<style scoped>
  .dropZone {
    width: 80%;
    height: 150px;
    position: relative;
    border: 2px dashed #eee;
  }

  .dropZone:hover {
    border: 2px solid #D8D8D8;
  }

  .dropZone:hover .dropZone-title {
    color: #1975A0;
  }

  .dropZone-info {
    color: #A8A8A8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  ..dropZone-title {
    color: #787878;
  }

  .dropZone input {
    position: absolute;
    cursor: pointer;
    top: 0px;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  .dropZone-upload-limit-info {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
  }

  .dropZone-over {
    background: #D8D8D8;
    opacity: 0.8;
  }

  .dropZone-uploaded {
    width: 80%;
    height: 200px;
    position: relative;
    border: 2px dashed #eee;
  }

  .dropZone-uploaded-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #D8D8D8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  .removeFile {
    width: 200px;
  }
</style>

<!-- 1674 -->